import { connect } from "react-redux";
import { getCourseCategoriesWithUserCourse } from "../../selectors/configSelectors";
import { getCurrentUser } from "../../selectors/userSelectors";
import MyCourses from "./MyCourses";

function mapStateToProps(state) {
  return {
    user: getCurrentUser(state),
    loading: state.coursesList.loading,
    courseCategories: getCourseCategoriesWithUserCourse(state),
  };
}

export default connect(mapStateToProps)(MyCourses);
